import React, { useCallback, useEffect, useRef, useState } from 'react';
import './style.scss';
import DynamicModal from '../../common/DynamicModal/DynamicModal';
import SingleOutputImageCustom from '../../common/SingleOutputImageCustom';
import { useDispatch } from 'react-redux';
import miscApi from '../../apis/misc';
import axios from 'axios';
import useCreditContext from '../../hooks/useCreditContext';
import {
  useDownloadImagesByDate,
  useGetMyGeneratedImages,
} from '../../hooks/useMyImages';
import InfiniteScroll from 'react-infinite-scroll-component';
import ImageCaraouselObject from '../../common/ImageCarouselObect';
// import ManualEditingObject from '../ManualEditingObject';
import downloadIcon from '../../Images/MyImages/downloadIconn.svg';
import { LoadingOutlined } from '@ant-design/icons';
import { message, Modal, Spin } from 'antd';
import { useSelector } from 'react-redux';
import { updateMyImagesDownloader } from '../../redux/Reducers/downloadImagesReducer';
import { useCancelTaskForMM } from '../../hooks/useCancelTask';
const { getPollOfTasks } = miscApi;

const GenerateMyImages = ({
  isSelectAllclickedForGenerated,
  setSelectAllclickedForGenerated,
  showData
}) => {
  const dispatch = useDispatch();

  const { generatedImages: genImagesForDownload } = useSelector(
    (select) => select?.myImagesDownloadReducer
  );
  const { refetchCredits } = useCreditContext();
  const intervalValue = useRef(null);
  const [openModal, setOpenModal] = useState(false);
  const [activeImageIndex, setActiveImageIndex] = useState(-1);
  const [pageNum, setPageNum] = useState(1);
  const [pageSize, setPageSize] = useState(50);
  const [totalImages, setTotalImages] = useState(0);
  const [pollingList, setPollingList] = useState([]);
  const [selectedOutputList, setSelectedOutputList] = useState([]);
  const currentIndex = useRef(0);
  const [generatedData, setGeneratedData] = useState({});
  const [currentDataLength, setCurrentDataLength] = useState(0);
  const [openManualEditing, setOpenManualEditing] = useState(false);
  const [isFirstTimeLoading, setIsFirstTimeLoading] = useState(true);
  const [isCancelConfirmOpen, setIsCancelConfirm] = useState(false);
  const [selectedTaskId, setSelectedTaskId] = useState('');
  useEffect(() => {
    currentIndex.current = 0;
  }, []);

  useEffect(() => {
    if (isSelectAllclickedForGenerated) {
      let filteredData = [];
      if (Object.keys(generatedData)?.length > 0) {
        Object.keys(generatedData).map((commonDate, index) => {
          if (generatedData[commonDate]?.length > 0) {
            generatedData[commonDate]?.map((rImg, index) => {
              const imageOutput = rImg?.output?.[rImg?.output?.dataType];
              if (rImg?.isSuccess) {
                filteredData.push(imageOutput?.image?.imagePath);
              }
            });
          }
        });
        dispatch(
          updateMyImagesDownloader({
            generatedImages: filteredData,
          })
        );
        setSelectAllclickedForGenerated(false);
      } else {
        setSelectAllclickedForGenerated(false);
        dispatch(
          updateMyImagesDownloader({
            generatedImages: [],
          })
        );
      }
    }
  }, [isSelectAllclickedForGenerated]);

  const getManualEdiitngComment = (item) => {
    let comment = '';
    comment = item?.input?.manualEditing?.editingMarkings?.length
      ? item?.input?.manualEditing?.editingMarkings[0]?.comment?.trim()
      : '';
    if (item?.taskType === 'bodySwap') {
      comment =
        item?.attachedManualEditing?.manualEditingTask?.input?.manualEditing?.editingMarkings[0]?.comment?.trim() ||
        '';
    }

    return comment;
  };

  const getModifiedData = (data, date) => {
    let outputArray = [];
    outputArray = data?.map((riImg) => {
      let indexToApply = currentIndex?.current;
      currentIndex.current = currentIndex?.current + 1;
      return {
        taskId: riImg?._id,
        isFailed: riImg?.status === 608 ? true : false,
        isSuccess: riImg?.status === 606 ? true : false,
        isLoading:
          riImg?.status !== 606 &&
          riImg?.status !== 608 &&
          riImg?.status !== 607
            ? true
            : false,
        responseUrl: '',
        responsekey: '',
        inputImage: '',
        outputImage: '',
        status: riImg?.status,
        input: riImg?.input,
        output: riImg?.status !== 606 ? null : riImg?.output,
        isEdited: riImg?.attachedManualEditing?.manualEditingTask
          ? riImg?.attachedManualEditing?.status === 606 ||
            riImg?.attachedManualEditing?.status === 608
            ? true
            : false
          : false,
        isEditing: riImg?.attachedManualEditing?.manualEditingTask
          ? riImg?.attachedManualEditing?.status !== 606 &&
            riImg?.attachedManualEditing?.status !== 608
            ? true
            : false
          : false,
        index: indexToApply,
        editingStatus:
          (riImg?.attachedManualEditing?.manualEditingTask &&
            riImg?.attachedManualEditing?.status) ||
          null,
        date,
        manualEditingComment: getManualEdiitngComment(riImg),
        isCancellable: riImg?.isCancellable,
      };
    });
    return outputArray;
  };

  function onSuccessList(data) {
    if (pageNum === 1) {
      let dataToModify = { ...data?.data?.data };
      let keysArray = Object.keys(dataToModify)?.sort((a, b) => a - b);
      let keysObj = {};
      keysArray.forEach((date) => {
        keysObj[date] = getModifiedData(dataToModify[date], date) || [];
      });
      let totalItems = Object.keys(keysObj).reduce((acc, item) => {
        acc = acc + Object.values(keysObj[item])?.length;
        return acc;
      }, 0);
      setCurrentDataLength(totalItems);
      setGeneratedData(keysObj);
      setIsFirstTimeLoading(false);
    } else {
      let dataToModify = { ...data?.data?.data };
      let alreadyData = { ...generatedData };
      let keysArray = Object.keys(dataToModify)?.sort((a, b) => a - b);
      let keysObj = { ...alreadyData };
      keysArray.forEach((date) => {
        if (keysObj[date]) {
          if (dataToModify[date]) {
            keysObj[date] = [
              ...keysObj[date],
              ...getModifiedData(dataToModify[date], date),
            ];
          }
        } else {
          keysObj[date] = getModifiedData(dataToModify[date], date) || [];
        }
      });
      let totalItems = Object.keys(keysObj).reduce((acc, item) => {
        acc = acc + Object.values(keysObj[item])?.length;
        return acc;
      }, 0);
      setCurrentDataLength(totalItems);
      setGeneratedData(keysObj);
    }

    setTotalImages(data?.data?.totalCount);

    if (activeImageIndex !== -1 && openModal) {
      handleNext();
    }
    setIsFirstTimeLoading(false);
  }

  function onErrorList(err) {
    setIsFirstTimeLoading(false);
  }

  let userTimeZone = Intl.DateTimeFormat().resolvedOptions().timeZone;
  const {
    data: generatedImages,
    isFetching: isFetchingGeneratedData,
    refetch,
  } = useGetMyGeneratedImages(
    'fetching-generated-imagest-list',
    pageNum,
    pageSize,
    '',
    userTimeZone,
    'modelClipper',
    '',
    onSuccessList,
    onErrorList
  );

  const onSuccessDateDownload = (res) => {
    if (res.status == 200) {
      window.open(res.data.data.url);
    }
  };
  const onErrorDateDownload = (err) => {
    console.log(err);
  };
  const { mutate: downloadImageByDate } = useDownloadImagesByDate(
    onSuccessDateDownload,
    onErrorDateDownload
  );

  const handleDateWiseDownload = (date) => {
    let payload = { userTimeZone: userTimeZone, date: date };
    downloadImageByDate(payload);
  };
  useEffect(() => {
    refetchCredits();
  }, [pollingList]);

  const fetchGeneratedData = useCallback(
    async (pollList) => {
      let pollIds = pollList?.map((singleItem) =>
        singleItem?.taskId.toString()
      );

      intervalValue.current = setInterval(async () => {
        try {
          let apiResult = await getPollOfTasks({
            taskIds: [...pollIds],
          });
          if (apiResult?.data?.data?.length > 0) {
            let dataResponse = apiResult?.data?.data;
            let dataWithoutLoadingResponse = dataResponse?.filter(
              (task) => task?.status === 606 || task?.status === 608
            );
            if (dataWithoutLoadingResponse?.length > 0) {
              let currentModifiedData = { ...generatedData };
              dataWithoutLoadingResponse?.forEach((task) => {
                Object.keys(currentModifiedData).forEach((date) => {
                  currentModifiedData[date]?.forEach((tsk) => {
                    if (tsk?.taskId === task?.id) {
                      tsk['isSuccess'] = task?.status === 606 ? true : false;
                      tsk['isLoading'] = false;
                      tsk['isFailed'] = task?.status === 608 ? true : false;
                      tsk['input'] = task?.input;
                      tsk['output'] =
                        task?.status !== 606 ? null : task?.output;
                    }
                  });
                });
              });
              setGeneratedData({ ...currentModifiedData });
              clearInterval(intervalValue?.current);
            }
          }
        } catch (err) {
          console.log(err);
        }
      }, 7000);
    },
    [pollingList?.length]
  );

  useEffect(() => {
    let generatedCopy = { ...generatedData };
    let loadingItems = [];
    clearInterval(intervalValue?.current);
    loadingItems = Object.keys(generatedCopy).reduce((acc, date) => {
      generatedCopy[date]?.forEach((itm) => {
        if (itm?.isLoading === true) {
          acc.push(itm);
        }
      });

      return acc;
    }, []);
    if (loadingItems?.length > 20) {
      let limitedItems = loadingItems?.slice(0, 20);
      setPollingList(limitedItems);
    } else {
      setPollingList(loadingItems);
    }
  }, [generatedData]);

  useEffect(() => {
    if (pollingList?.length) {
      fetchGeneratedData(pollingList);
    }
  }, [pollingList]);

  useEffect(() => {
    return () => {
      clearInterval(intervalValue?.current);
    };
  }, []);

  const toDataURL = async (url) => {
    const response = await axios.get(url, { responseType: 'blob' });
    const imageDataUrl = URL.createObjectURL(response.data);
    return imageDataUrl;
  };
  const handleImageSelection = (imageData) => {
    let data = [...genImagesForDownload];
    if (data.some((task) => task?._id == imageData?._id)) {
      let filteredData = data.filter((task) => {
        return task._id != imageData?._id;
      });
      setSelectedOutputList(filteredData);
      dispatch(
        updateMyImagesDownloader({
          generatedImages: filteredData,
        })
      );
    } else {
      data.push(imageData);
      setSelectedOutputList(data);
      dispatch(
        updateMyImagesDownloader({
          generatedImages: data,
        })
      );
    }
  };
  const getFileExtension = (url) => {
    return url.split('.').pop().split(/\#|\?/)[0];
  };

  const handleDownload = async (imageUrl) => {
    const extension = getFileExtension(imageUrl);
    const a = document.createElement('a');
    a.href = await toDataURL(imageUrl);
    a.download = `flixstock_generated_model.${extension}`;
    document.body.appendChild(a);
    a.click();
    document.body.removeChild(a);
  };
  const handleNext = useCallback(() => {
    let nextIndex = activeImageIndex + 1;
    let originalNext = activeImageIndex;
    let allData = { ...generatedData };
    if (
      nextIndex > currentDataLength - 1 &&
      nextIndex < totalImages &&
      currentDataLength < totalImages
    ) {
      // setActiveImageIndex(originalNext);
      setPageNum((p) => pageNum + 1);
      return;
    } else {
      let indexData = Object.keys(generatedData).reduce((acc, date) => {
        let itemsToCheck = generatedData[date];
        for (let i = 0; i < itemsToCheck?.length; i++) {
          if (itemsToCheck[i]?.index === nextIndex) {
            if (!itemsToCheck[i]?.isSuccess) {
              ++nextIndex;
            } else {
              setActiveImageIndex(nextIndex);
            }
          }
        }

        if (
          activeImageIndex === originalNext &&
          nextIndex > currentDataLength - 1 &&
          nextIndex < totalImages &&
          currentDataLength < totalImages
        ) {
          setPageNum((p) => pageNum + 1);
          return;
        }
      }, {});
    }
    if (nextIndex > totalImages - 1) {
      setActiveImageIndex(originalNext);
    }
  }, [
    activeImageIndex,
    generatedData,
    pageNum,
    currentDataLength,
    totalImages,
  ]);
  const handlePrevious = useCallback(() => {
    let prevIndx = activeImageIndex - 1;
    let originalPrev = activeImageIndex;

    let indexData = Object.keys(generatedData).reduce((acc, date) => {
      let itemsToCheck = generatedData[date];
      for (let i = itemsToCheck?.length - 1; i >= 0; i--) {
        if (itemsToCheck[i]?.index === prevIndx) {
          if (!itemsToCheck[i]?.isSuccess) {
            --prevIndx;
          } else {
            setActiveImageIndex(prevIndx);
          }
        }
      }

      if (prevIndx < 0) {
        setActiveImageIndex(originalPrev);
      }
    }, {});
  }, [activeImageIndex, generatedData]);

  useEffect(() => {
    const handleKeyDown = (event) => {
      if (event.key === 'ArrowRight') {
        handleNext();
      } else if (event.key === 'ArrowLeft') {
        handlePrevious();
      }
    };

    window.addEventListener('keydown', handleKeyDown);

    return () => {
      window.removeEventListener('keydown', handleKeyDown);
    };
  }, [activeImageIndex, handleNext, handlePrevious]);

  const handleManualEditingBtn = () => {
    setOpenModal(false);
    setOpenManualEditing(true);
  };

  const handleManualEdit = (index) => {
    setOpenManualEditing(true);
    setActiveImageIndex(index);
  };

  const setActiveImage = (indexImage) => {
    setActiveImageIndex(indexImage?.index);
  };

  // const getManualEditingModal = () => {
  //   return (
  //     <DynamicModal
  //       open={openManualEditing}
  //       closable={true}
  //       close={() => setOpenManualEditing(false)}
  //       footer={null}
  //       width={'100%'}
  //       height={'90dvh'}
  //       classWrapper="manual_editing_modal_object"
  //       component={
  //         <ManualEditingObject
  //           imagesData={generatedData}
  //           activeIndex={activeImageIndex}
  //           isDate={true}
  //           setGeneratedData={setGeneratedData}
  //           handleCloseView={() => setOpenManualEditing(false)}
  //         />
  //       }
  //     />
  //   );
  // };

  const getPreviewModal = () => {
    return (
      <DynamicModal
        open={openModal}
        closable={true}
        close={() => {
          setActiveImageIndex(-1);
          setOpenModal(false);
        }}
        footer={null}
        width={'100%'}
        height={'95dvh'}
        classWrapper="image_preview_caraousel_object"
        component={
          <ImageCaraouselObject
            imagesData={generatedData}
            activeIndex={activeImageIndex}
            handleNext={handleNext}
            handlePrevious={handlePrevious}
            handleImageDownload={handleDownload}
            totalImages={totalImages}
            currentDataLength={currentDataLength}
            handleManualEditingBtn={handleManualEditingBtn}
            isLoadingData={isFetchingGeneratedData}
            setActiveImage={setActiveImage}
            handleCloseView={() => {
              setActiveImageIndex(-1);
              setOpenModal(false);
            }}
          />
        }
      />
    );
  };
  const handlePreview = (index) => {
    setActiveImageIndex(index);
    setOpenModal(true);
  };

  const getShowableDate = (idate) => {
    const today = new Date(idate);
    const day = today.toLocaleString('default', { weekday: 'short' });
    const date = today.getDate();
    const month = today.toLocaleString('default', { month: 'short' });
    const year = today.toLocaleString('default', { year: 'numeric' });
    const time = today.toLocaleTimeString([], {
      hour: 'numeric',
      minute: '2-digit',
      hour12: true,
    });
    return `${day} ${date} ${month}, ${year}`;
  };
  function onSuccessCancelItems(data) {
    if (data?.data?.success) {
      message.success('Image Generation Cancelled');
      setIsCancelConfirm(false);
    } else {
      message.error('Image Cancellation failed');
      setIsCancelConfirm(false);
    }
    refetch();
  }

  function onErrorCancelItems(err) {
    message.error(err?.response?.message);
  }

  const { mutate: handleCancelMM } = useCancelTaskForMM(
    onSuccessCancelItems,
    onErrorCancelItems
  );

  const handleCancelGeneration = (data) => {
    let payloadGenerate = {
      taskId: data,
    };
    handleCancelMM(payloadGenerate);
  };
  const handleOk = () => {
    handleCancelGeneration(selectedTaskId);
  };
  const handleCancel = () => {
    setIsCancelConfirm(false);
  };

  const getConfirmCancelModal = () => {
    return (
      <Modal
        title="Cancel Generation"
        centered
        open={isCancelConfirmOpen}
        onOk={handleOk}
        onCancel={handleCancel}
        wrapClassName="modal_wrapper"
        okText={'Confirm'}
      >
        <p>Are you sure you want to cancel?</p>
      </Modal>
    );
  };
  const handleConfirmCancelModal = (data) => {
    console.log(data);
    setIsCancelConfirm(true);
    setSelectedTaskId(data);
  };
  const getDateWiseData = () => {
    return (
      <div className="my_generated_images_main">
        <div className="my_generated_images_wrapper" id="scrollableDiv">
          <InfiniteScroll
            dataLength={currentDataLength}
            next={() => {
              if (currentDataLength < totalImages) {
                setPageNum((prev) => pageNum + 1);
              } else {
                return;
              }
            }}
            hasMore={true}
            loader={<h4></h4>}
            scrollableTarget="scrollableDiv"
          >
            
                <div className="dated-section">
                  {/* <div className="date_section">
                    {getShowableDate(commonDate)}
                    <img
                      src={downloadIcon}
                      alt="downloadIcon"
                      onClick={() => handleDateWiseDownload(commonDate)}
                    />
                  </div> */}
                  <div className="image_section">
                    {Array.isArray(showData) &&
                      showData?.map((rImg, index) => {
                        console.log('rImg', rImg);
                        return (
                          <SingleOutputImageCustom
                            item={rImg}
                            handlePreview={() => handlePreview(rImg?.index)}
                            handleDownload={handleDownload}
                            handleImageSelection={handleImageSelection}
                            handleManualEdit={() => {
                              handleManualEdit(rImg?.index);
                            }}
                            handleConfirmCancelModal={handleConfirmCancelModal}
                          />
                        );
                      })}
                  </div>
                </div>
            
          </InfiniteScroll>
        </div>
        {genImagesForDownload.length > 0 && (
          <div className="overlay_count_container">
            {genImagesForDownload.length == 1
              ? genImagesForDownload.length + ' image selected '
              : genImagesForDownload.length + ' images selected'}
          </div>
        )}
      </div>
    );
  };

  return (
    <div className="generate_My_Images_main_wrapper">
      <div className="output_section">
        {isFirstTimeLoading && (
          <div className="first_time_loading">
            <Spin
              indicator={
                <LoadingOutlined
                  style={{
                    fontSize: 24,
                  }}
                  spin
                />
              }
            />
          </div>
        )}
        {getDateWiseData()}
      </div>
      {openModal && getPreviewModal()}
      {/* {openManualEditing && getManualEditingModal()} */}
      {isCancelConfirmOpen && getConfirmCancelModal()}
    </div>
  );
};
export default GenerateMyImages;
